var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h20v20H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.114 10.349v1.362l.27.063.212.056c1.528.446 2.457 1.661 2.602 2.975h-.924l-.987.018-.006-.035c-.182-.76-.851-1.275-2.11-1.275-1.706 0-2.935.69-2.935 1.643 0 .261.013.404.082.591.247.667 1.039 1.016 2.6 1.049l.253.003c3.51 0 4.822 1.415 4.822 3.528 0 1.627-1.361 3.05-3.587 3.424l-.292.049v1.348h-1.886v-1.345l-.295-.047-.25-.044c-1.957-.387-3.068-1.584-3.291-2.89l-.021-.145h1.939l.011.033c.081.202.223.409.441.598.491.424 1.278.662 2.41.662 1.727 0 2.935-.73 2.935-1.643 0-.295-.025-.475-.144-.7-.31-.587-1.1-.906-2.532-.94l-.26-.003c-3.51 0-4.821-1.415-4.821-3.528 0-1.627 1.361-3.05 3.586-3.424l.293-.049-.001-1.334h1.886z",
    fill: "#2F665C",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfit);
export default __webpack_public_path__ + "static/media/ic-profit.b2c912e98d6ada59c83cbbb37001c76c.svg";
export { ForwardRef as ReactComponent };